import { useMemo } from 'react';
import { useRouter } from 'next/router';
import useGetSubscriptionQuery from '@/v2/domains/Subscriptions/queries/useGetSubscriptionQuery.hook';
import { subscriptionStatus } from '@rockalingua/shared/subscriptions/constants';

import { useExpiredSubscriptionModalStore } from '../../stores/useExpiredSubscriptionModal.store';
import ExpiredSubscriptionBanner from '../ExpiredSubscriptionBanner/ExpiredSubscriptionBanner';
import { Modal, ModalContent } from './ExpiredSubscriptionModal.styled';

export default function ExpiredSubscriptionModal() {
  const { data: subscription } = useGetSubscriptionQuery();
  const { modalClosed } = useExpiredSubscriptionModalStore();
  const router = useRouter();

  const isActivityPage = !!router.query.activitySlug;

  const showModal = useMemo(
    () =>
      subscription?.status == subscriptionStatus.EXPIRED &&
      !modalClosed &&
      !isActivityPage,
    [subscription?.status, modalClosed, isActivityPage]
  );

  if (!showModal) {
    return null;
  }

  return (
    <Modal visible={showModal} footer={null} closable={false}>
      <ModalContent>
        <ExpiredSubscriptionBanner />
      </ModalContent>
    </Modal>
  );
}
